import React from 'react';

export interface SkeletonProps {
  variant?: 'text' | 'circular' | 'rectangular';
  width?: string | number;
  height?: string | number;
  className?: string;
}

const variantClasses: Record<NonNullable<SkeletonProps['variant']>, string> = {
  text: 'rounded',
  circular: 'rounded-full',
  rectangular: 'rounded-md',
};

export const Skeleton: React.FC<SkeletonProps> = ({
  variant = 'text',
  width,
  height,
  className = '',
}) => {
  const style: React.CSSProperties = {};
  if (width !== undefined) style.width = typeof width === 'number' ? `${width}px` : width;
  if (height !== undefined) style.height = typeof height === 'number' ? `${height}px` : height;

  return (
    <div
      data-skeleton-motion="shimmer"
      className={`skeleton-shimmer bg-slate-700/50 motion-reduce:animate-none ${variantClasses[variant]} ${className}`}
      style={style}
      aria-hidden="true"
    />
  );
};
